import { useReducer } from 'react';
import { FriendsViewReducer } from './friendsReducer';
import { FriendsViewContext } from './friendsContext';
import { UPDATE_FRIENDS_VIEW } from './types';

export const FriendsViewState = (props) => {

    const initialState = {
        friendsViewData: {
            openDisclosure: false,
        }
    }

    const [state, dispatch] = useReducer(FriendsViewReducer, initialState);

    const updateFriendsView = (data) => {
        dispatch({
            type: UPDATE_FRIENDS_VIEW,
            payload: data
        });
    }

    return (
        <FriendsViewContext.Provider value={
            {
                friendsViewData: state.friendsViewData,
                updateFriendsView
            }}>
            {props.children}
        </FriendsViewContext.Provider>
    )
}


